import React, {useContext, useMemo, useEffect} from "react";
import { useNavigate } from "react-router-dom";
import { MyContext } from "../../../../Context/MyContext";
import PropertyCard from "../home/Poperty/PropertyCard";
import "./MyBookings.css"; // reuse same styling
import AppIcon from "../../../../Components/AppIcon";

const MyWishlist = ({ setActiveView }) => {
const {
  wishlist,
  properties,
  fetchProperties,
  propLoading,
} = useContext(MyContext);
  const navigate = useNavigate();

  useEffect(() => {
  if (!properties.length) {
    fetchProperties();
  }
}, []);

  // ✅ Get wishlist properties
const wishlistData = useMemo(() => {
  return properties.filter(p =>
    wishlist.map(String).includes(String(p.id))
  );
}, [wishlist, properties]);

  return (
    <div className="mbk-page">

      {/* Top bar */}
      <div className="mbk-topbar">
        <button className="mbk-back" onClick={() => setActiveView("content")}>
          ← Back
        </button>
        <div>
          <h2 className="mbk-title">My Wishlist</h2>
          <p className="mbk-sub">Your saved favorite properties</p>
        </div>
      </div>
      
      {/* Empty */}
      {wishlistData.length === 0 ? (
        <div className="mbk-empty">
          <div className="mbk-empty-icon">
            <AppIcon name="wishlist" size={40} />
          </div>
          <h3>No Wishlist Yet</h3>
          <p>Save properties to see them here.</p>
          <button
            className="mbk-browse-btn"
            onClick={() => navigate("/properties")}
          >
            Browse Properties
          </button>
        </div>
      ) : (
       <div className="profile-cards1">
  {wishlistData.map(property => (
    <PropertyCard
      key={property.id}
      property={property}
      badgeLabel="Wishlist"
      badgeColor="#ff4d6d"
    />
  ))}
</div>
      )}
    </div>
  );
};

export default MyWishlist;

